import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from '@material-ui/core/DialogContentText';
import { useTranslation } from "react-i18next";
import {properCase } from "utils/index";

const MealsAlertDialog = (props) => {
  const { t } = useTranslation();
  const { mealModalVisible, hideMealModal, actionRootClass } = props;

  return (
      <Dialog
        open={mealModalVisible}
        onClose={hideMealModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth= {true}
      >
        
        <DialogTitle id="simple-dialog-title">{properCase(t("other.dlReturnMealTitle"))} </DialogTitle>
        <DialogContent>
        <DialogContentText>
        {t("other.dlReturnMealMessage")}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={actionRootClass}>
        {props.children}
      </DialogActions>
      </Dialog>
  );
};

export default MealsAlertDialog;